import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetErpPoList } from '@/api/SubDeliveryNote';
import util from '@/libs/util';
export default {
  props: {
    isShowaddOrderRowDialog: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      loading: false,
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      keyName: 'BILL_NO',
      keyList: [// { value: 'ALL', label: "全部" },
      {
        value: 'BILL_NO',
        label: '采购订单号'
      } // { value: 'PART_NO', label: "物料编码" },
      // { value: 'PART_NAME', label: "物料名称" },
      // { value: 'PART_DESCR', label: "规格描述" },
      // { value: 'PO_UNIT', label: "采购单位" }
      ],
      keyCode: null,
      DELIVERY_NO: null,
      currentRow: null // 表格选中的

    };
  },
  methods: {
    handleInputClear: function handleInputClear() {
      this.keyCode = null;

      this._getErpPOlist();
    },
    checCheckboxkMethod: function checCheckboxkMethod(_ref) {
      var row = _ref.row;
      return row.isChecked === false;
    },
    // 单据类型搜索选择
    handelChangeKeyType: function handelChangeKeyType() {
      this.keyCode = null;

      if (this.keyName === 'ALL') {
        this._getErpPOlist();
      }
    },
    currentChange: function currentChange(_ref2) {
      var newValue = _ref2.newValue,
          oldValue = _ref2.oldValue,
          row = _ref2.row,
          rowIndex = _ref2.rowIndex,
          $rowIndex = _ref2.$rowIndex,
          column = _ref2.column,
          columnIndex = _ref2.columnIndex,
          $columnIndex = _ref2.$columnIndex,
          $event = _ref2.$event;
      // console.log(row);
      // console.log(rowIndex);
      // console.log($rowIndex);
      this.$refs.xTable.toggleCheckboxRow(this.tabelData[rowIndex]);
    },
    // 行样式
    rowClassName: function rowClassName() {
      return 'rowClass';
    },
    _getErpPOlist: function _getErpPOlist() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res, checkList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('currentRow',currentRow);
                _this.tabelData = [];
                params = {
                  Page: 1,
                  Limit: 999,
                  Key: '',
                  BILL_NO: _this.keyCode,
                  PART_STATE: 3,
                  VENDOR_CODE: _this.DELIVERY_NO,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                }; // let params = {}
                // if(this.keyName === 'ALL'){
                //     params = obj
                // }else{
                //     obj[this.keyName] = this.keyCode
                //     params = obj
                // }

                _this.loading = true;
                _context.next = 5;
                return GetErpPoList(params);

              case 5:
                res = _context.sent;
                _this.loading = false; // console.log('采购订单列表',res);
                // console.log('currentRow',currentRow);

                if (res.code === 0) {
                  if (_this.currentRow instanceof Array) {
                    // this.tabelData = this.deWeight(res.data.Items,this.currentRow)
                    _this.tabelData = res.data.Items;
                    checkList = _this.hasCheckboxRow(currentRow, _this.tabelData);
                    console.log('checkList', checkList); // this.$refs.xTable.setCheckboxRow(checkList, true)
                  } else {
                    _this.tabelData = res.data.Items;
                  }

                  _this.$forceUpdate();
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    hasCheckboxRow: function hasCheckboxRow(currentRow, asyncRow) {
      var check = [];
      asyncRow.forEach(function (a_item) {
        a_item.isChecked = false;
        currentRow.forEach(function (c_item) {
          if (a_item.BILL_NO === c_item.PO_NO && a_item.BILL_ITEM === c_item.PO_ITEM && a_item.PART_NO === c_item.PART_NO) {
            // console.log(a_item);
            a_item.isChecked = true;
            check.push(a_item);
          }
        });
      });
      return check; // console.log('filterRow',asyncRow.filter((v) => currentRow.every((c_val) => c_val.PART_NO === v.PART_NO)));
    },
    // 去重
    deWeight: function deWeight(asyncRow, currentRow) {
      console.log('asyncRow', asyncRow);
      console.log('currentRow', currentRow); // let currentRow = this.$refs.xTable.getTableData().visibleData
      // return asyncRow.filter((v) => currentRow.every((val) => val.PO_NO != v.PO_NO && val.BILL_ITEM != v.BILL_ITEM && val.BILL_ITEM != v.BILL_ITEM));
      // erpList
      // BILL_ITEM  采购项次
      // BILL_NO  采购单号
      // PART_NO  物料号
      // 选中List
      // PO_ITEM  采购项次
      // PO_NO  采购单号
      // PART_NO  物料号

      return asyncRow.filter(function (v) {
        return currentRow.every(function (c_val) {
          return c_val.PART_NO != v.PART_NO && c_val.PO_NO != v.BILL_NO && c_val.PO_ITEM != v.BILL_ITEM;
        });
      });
    },
    getErpPOlist: function getErpPOlist(DELIVERY_NO, currentRow) {
      console.log('currentRow', currentRow);
      this.currentRow = currentRow;
      this.DELIVERY_NO = DELIVERY_NO;
      this.tabelData = [];

      this._getErpPOlist();
    },
    handleCancel: function handleCancel() {
      this.keyCode = null;
      this.$emit('closeaddOrderRowDialog');
    },
    // 获取当前时间
    getNowDate2: function getNowDate2(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var H = date.getHours();
      var M = date.getMinutes();
      var S = date.getSeconds(); // return y + '-' + m + '-' + d + ' ' + H + ':' + M + ':' + S

      return y + '-' + m + '-' + d;
    },
    // 获取当前时间
    getNowDate: function getNowDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y.toString() + m.toString() + d.toString();
    },
    handleDelSubmit: function handleDelSubmit() {
      var _this2 = this;

      var selectRecords = this.$refs.xTable.getCheckboxRecords();
      var time = this.getNowDate2(new Date());
      console.log('time', selectRecords);
      var now = this.getNowDate(new Date());
      var arr = [];
      selectRecords.forEach(function (item) {
        item.LINE_NO = Number(item.BILL_ITEM);
        item.PO_TYPE = item.BILL_TYPE;
        item.ATTRIBUTE1 = item.PURCHASER;
        item.PO_NO = item.BILL_NO;
        item.PO_ITEM = item.BILL_ITEM;
        item.DELIVERY_QTY = item.REMAINING_QTY; // po可交

        item.PO_REMAINING_QTY = item.REMAINING_QTY;
        item.PO_TOTAL_QTY = item.QTY;
        item.LOT_NO = now;
        item.DATE_CODE = time;
        item.MST_ID = _this2.MSTID;
        item.PACKING_QTY = item.BOX_QTY ? item.BOX_QTY : 0;
        item.SPQ = item.CASE_QTY ? item.CASE_QTY : 0;
        item.DESCRIPTION = item.FNote ? item.FNote : '';
        item.CREATETIME = item.CREATETIME;
        arr.push(item);
      }); // arr.forEach((v,k) => {
      //     if (k < 9) {
      //         v.LOT_NO = v.LOT_NO + '0' + (k + 1)
      //     } else {
      //         v.LOT_NO = v.LOT_NO + (k + 1)
      //     }
      // });
      // console.log('选中的行',selectRecords);
      // console.log('输出的arr',arr);

      this.$emit('cbDialogSubmit', arr);
      this.$emit('closeaddOrderRowDialog');
    }
  }
};